import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockColumnItem extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        super(model, children);
        this.width = model.width;
    }
}
